// extracted by mini-css-extract-plugin
export var banner = "_ip-0";
export var closeButton = "_ip-2";
export var greenCheckmark = "_ip-3";
export var hereLink = "_ip-4";
export var titleIcon = "_ip-1";